import * as ambassadorWixSiteActionsV1SiteActions from './site-actions-v1-site-actions-site-actions.http.js';
import * as ambassadorWixSiteActionsV1SiteActionsTypes from './site-actions-v1-site-actions-site-actions.types.js';
import * as ambassadorWixSiteActionsV1SiteActionsUniversalTypes from './site-actions-v1-site-actions-site-actions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function publishSite(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.PublishSiteRequest,
  ambassadorWixSiteActionsV1SiteActionsTypes.PublishSiteRequest,
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.PublishSiteResponse,
  ambassadorWixSiteActionsV1SiteActionsTypes.PublishSiteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSiteActionsV1SiteActions.publishSite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/site/publish',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deployStandalonePages(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.DeployStandalonePagesRequest,
  ambassadorWixSiteActionsV1SiteActionsTypes.DeployStandalonePagesRequest,
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.DeployStandalonePagesResponse,
  ambassadorWixSiteActionsV1SiteActionsTypes.DeployStandalonePagesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSiteActionsV1SiteActions.deployStandalonePages(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/site/deploy-standalone-pages',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function duplicateSite(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.DuplicateSiteRequest,
  ambassadorWixSiteActionsV1SiteActionsTypes.DuplicateSiteRequest,
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.DuplicateSiteResponse,
  ambassadorWixSiteActionsV1SiteActionsTypes.DuplicateSiteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSiteActionsV1SiteActions.duplicateSite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/sites/duplicate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteSite(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.BulkDeleteSiteRequest,
  ambassadorWixSiteActionsV1SiteActionsTypes.BulkDeleteSiteRequest,
  ambassadorWixSiteActionsV1SiteActionsUniversalTypes.BulkDeleteSiteResponse,
  ambassadorWixSiteActionsV1SiteActionsTypes.BulkDeleteSiteResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixSiteActionsV1SiteActions.bulkDeleteSite(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/sites/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EmptyEntity as EmptyEntityOriginal,
  PublishSiteRequest as PublishSiteRequestOriginal,
  PublishSiteResponse as PublishSiteResponseOriginal,
  DeployStandalonePagesRequest as DeployStandalonePagesRequestOriginal,
  DeployStandalonePagesResponse as DeployStandalonePagesResponseOriginal,
  DuplicateSiteRequest as DuplicateSiteRequestOriginal,
  DuplicateSiteResponse as DuplicateSiteResponseOriginal,
  BulkDeleteSiteRequest as BulkDeleteSiteRequestOriginal,
  BulkDeleteSiteResponse as BulkDeleteSiteResponseOriginal,
  BulkSiteResult as BulkSiteResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  RenameSiteRequest as RenameSiteRequestOriginal,
  RenameSiteResponse as RenameSiteResponseOriginal,
  ValidateSiteNameRequest as ValidateSiteNameRequestOriginal,
  ValidateSiteNameResponse as ValidateSiteNameResponseOriginal,
  UnpublishSiteRequest as UnpublishSiteRequestOriginal,
  UnpublishSiteResponse as UnpublishSiteResponseOriginal,
  MoveSiteToTrashRequest as MoveSiteToTrashRequestOriginal,
  MoveSiteToTrashResponse as MoveSiteToTrashResponseOriginal,
  RestoreSiteFromTrashRequest as RestoreSiteFromTrashRequestOriginal,
  RestoreSiteFromTrashResponse as RestoreSiteFromTrashResponseOriginal,
  DeleteSiteFromTrashRequest as DeleteSiteFromTrashRequestOriginal,
  DeleteSiteFromTrashResponse as DeleteSiteFromTrashResponseOriginal,
  CreateAndAttachChildRequest as CreateAndAttachChildRequestOriginal,
  CreateAndAttachChildResponse as CreateAndAttachChildResponseOriginal,
  PublishSiteApplicationErrors as PublishSiteApplicationErrorsOriginal,
  DeployStandalonePagesApplicationErrors as DeployStandalonePagesApplicationErrorsOriginal,
} from './site-actions-v1-site-actions-site-actions.types.js';
